import $ from 'jquery';
import CurrencyConverter from 'shopify-currency-converter';
import Quantity from '../snippets/Quantity';
import VariantHelper from '../VariantHelper';

export default class ProductForm {
  /**
   *
   * @param {Element} el
   * @param {Object} options
   * @param {Object} options.container
   * @param {Object} options.product
   * @param {String} options.moneyFormat
   * @param {Function} options.onAddToCart
   * @param {Function} options.onSuccess
   * @param {Function} options.onError
   * @param {Function} options.onVariantChange
   * @param {Function} options.onQuantityChange
   * @param {Function} options.postMessage
   */
  constructor(el, options = {}) {
    this.$el = $(options.container || el);
    this.$form = $(el);
    this.options = options;
    this.postMessage = this.options.postMessage;

    // History
    this.isThemeEditor = window.Shopify && window.Shopify.designMode;
    this.useHistory = options.useHistory && !this.isThemeEditor && window.history && history.replaceState;

    // Options
    this.$atc = this.$el.find('[data-product-atc]');
    this.$options = this.$el.find('[data-product-option]');
    this.$variants = this.$el.find('[data-variants]');
    this.variantHelper = new VariantHelper(this.options.product, this.$variants, this.$options);

    // Quantity
    this.quantity = new Quantity(this.$el.find('[data-quantity]'));

    // Events
    this.events = [
      // ATC
      this.$atc.on('click.product-form', event => {
        event.preventDefault();
        this._addToCart();
      }),

      // Switch variant
      $(window).on('product-variant-switch.product-form', (event, data) => {
        this._changeVariant(data);
      }),

      // Change quantity
      $(this.quantity.input).on('change.product-form', event => {
        if (this.options.onQuantityChange) {
          this.options.onQuantityChange(
            this.variantHelper.getSelectedVariant(),
            this.quantity.value
          );
        }
      }),
    ];
  }

  unload() {
    this.events.forEach($el => $el.off('.product-form'));
    this.quantity.unload();
    this.variantHelper.unload();
  }

  _changeVariant(data) {
    if (data.firstLoad) {
      return;
    }

    const variant = data.variant;
    const format = this.options.moneyFormat;

    // Update URL
    this._changeUrl(variant);

    // Compare at price
    this.$el.find('[data-variant-compare-at-price]')
      .toggleClass(
        'money-compare-at-hidden',
        (
          !variant.compare_at_price
          || variant.price === variant.compare_at_price
        ),
      )
      .text(Shopify.formatMoney(variant.compare_at_price, format))
      .each((index, el) => CurrencyConverter.update(el));

    // Price
    this.$el.find('[data-variant-price]')
      .text(Shopify.formatMoney(variant.price, format))
      .each((index, el) => CurrencyConverter.update(el));

    // Form-specific updates
    if (this.options.onVariantChange) {
      this.options.onVariantChange(variant);
    }

    // Notify sections
    this.postMessage('product:change-variant', { variant });
  }

  _changeUrl(variant) {
    if (!this.useHistory) {
      return;
    }

    const params = $.param({ variant: variant.id });
    const url = `${ this.options.product.handle }?${params}`;
    history.replaceState({}, 'variant', url);
  }

  _changeVariantInline(variant) {
    this.$el.find('.product-form-inline-atc-button')
      .prop('disabled', !variant.available)
      .text(variant.available
        ? this.section.data.text.product_available
        : this.section.data.text.product_unavailable
      );
  }

  _addToCart() {
    if (this.options.onAddToCart) {
      this.options.onAddToCart();
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: this.$form.serialize(),
      dataType: 'json',
    })

    // On success
    .done(response => {
      this._updateCart();

      if (this.options.onSuccess) {
        this.options.onSuccess(response, this.quantity.value);
      }
    })

    // On failure
    .fail((response) => {
      if (this.options.onError) {
        const responseText = JSON.parse(response.responseText);
        const error = responseText.description;

        this.options.onError(response, error);
      }
    });
  }

  _updateCart() {
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
    })
    .done(response => {
      this.postMessage('product:add-to-cart', { response });
    });
  }
}
